import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      persistent: "",
      width: "1000"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: _vm.cancel
    }
  })], 1), !_vm.isEdit ? _c(VCardTitle, {
    staticClass: "headline"
  }, [_vm._v("Add a new classification")]) : _c(VCardTitle, {
    staticClass: "headline"
  }, [_vm._v("Edit classification")]), _c("ClassificationComponent", {
    ref: "classification",
    attrs: {
      mode: "popin",
      baseModel: _vm.classification,
      isEdit: _vm.isEdit,
      loggedUserData: _vm.loggedUserData
    },
    on: {
      cancel: _vm.cancel,
      saved: _vm.agree
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };